import {
  disableCandidateById,
  enableCandidateById,
} from '@candidates/services/candidatesServices';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useEnableCandidate = () => {
  const useEnablCandidateMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => enableCandidateById(mutationVariables.id));

  return useEnablCandidateMutation;
};

export const useDisableCandidate = () => {
  const useEnableCandidateMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => disableCandidateById(mutationVariables.id));

  return useEnableCandidateMutation;
};
